import { SettingsRow, SettingsSection, SettingsToggle } from './SettingsControls'
import { useSettingsForm } from './useSettingsForm'

/* .NET custom-format strings, not the lowercase shapes the prototype drew. The
   value travels straight into DateTime.TryParseExact, where 'mm' means minutes:
   a lowercase month would parse nothing and fail every date column in the file. */
const DATE_FORMATS = ['yyyy-MM-dd', 'dd/MM/yyyy', 'MM/dd/yyyy', 'dd-MMM-yyyy']

export function SettingsGeneralTab() {
  const { draft, set } = useSettingsForm()

  return (
    <>
      <SettingsSection
        title="Regional Settings"
        help="Configure how your data files are parsed and interpreted."
      >
        <SettingsRow
          htmlFor="dateFormat"
          label="Date Format"
          help="How dates are read out of your uploaded file."
        >
          <select
            className="bb-select"
            id="dateFormat"
            value={draft.dateFormat}
            onChange={(event) => set('dateFormat', event.target.value)}
          >
            {(DATE_FORMATS.includes(draft.dateFormat)
              ? DATE_FORMATS
              : [draft.dateFormat, ...DATE_FORMATS]
            ).map((format) => (
              <option value={format} key={format}>
                {format}
              </option>
            ))}
          </select>
        </SettingsRow>

        {/* The server has always honoured this — ImportValidator coerces every
            Money, Number and Quantity cell through it — but the only screen that
            ever set it was the Import Settings modal, which the central Settings
            page replaced. That left a live setting with no way to reach it, so a
            file written as "1.234,56" parsed wrong with no recourse. */}
        <SettingsRow
          htmlFor="decimalSeparator"
          label="Decimal Separator"
          help="The character your file uses between the whole and fractional part of an amount."
        >
          <select
            className="bb-select"
            id="decimalSeparator"
            value={draft.decimalSeparator === ',' ? ',' : '.'}
            onChange={(event) => set('decimalSeparator', event.target.value)}
          >
            <option value=".">Period — 1,234.56</option>
            <option value=",">Comma — 1.234,56</option>
          </select>
        </SettingsRow>
      </SettingsSection>

      <SettingsSection
        title="File Parsing Options"
        help="Control how files are read and processed."
      >
        <SettingsToggle
          setting="firstRowIsHeader"
          label="First row contains column headers"
          help="Enable this if your file has a header row with column names."
        />
        <SettingsToggle
          setting="trimWhitespace"
          label="Trim leading and trailing spaces"
          help="Remove extra spaces from the beginning and end of each cell."
        />
      </SettingsSection>
    </>
  )
}
